import { styled } from '@mui/material/styles'
import I18n from 'i18n-js'
import PropTypes from 'prop-types'

import Button from '../../shared/Button'

const CTA = styled(Button)({
  position: 'relative',
  overflow: 'hidden',
  marginTop: '24px',
})

const PaidAdCTAActivate = ({ onClick }) => {
  return (
    <CTA
      buttonStyle="facebook"
      onClick={() => onClick()}
      width="large"
      data-testid="manageFacebookConnectionBtnCTA"
    >
      {I18n.t('content.manageFacebookConnection')}
    </CTA>
  )
}

PaidAdCTAActivate.propTypes = {
  onClick: PropTypes.func,
}

export default PaidAdCTAActivate
